import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, Flex, Heading, Button, Text } from "@aws-amplify/ui-react";
import CareNoteCard from "./CareNoteCard";
import { useCareNotesDirectQuery } from "./api/useCareNotesDirectQuery";
import { useUserQuery } from "../common/useUserQuery";

export default function CareNotesPage() {
  const navigate = useNavigate();
  const { data: userQueryData } = useUserQuery();
  const { data: careNotesQueryData, isLoading, isFetching } = useCareNotesDirectQuery(
    userQueryData?.patientUserId
  );
  return (
    <Flex
      direction="column"
      padding="32px 32px 32px 32px"
      backgroundColor="rgba(250,250,250,1)"
    >
      <Flex direction="row" alignItems="center">
        <Heading level="1" children="Care Notes"></Heading>
        <Button
          size="small"
          variation="primary"
          onClick={() => navigate("/user/hr/care-notes/add")}
        >
          Add
        </Button>
      </Flex>
      <Flex direction="column">
        <Card>
          <Heading level={4} children="Seeing notes from Caregivers" />
          {isFetching
            ? <><Text>Loading...</Text></>
            : careNotesQueryData?.map((carenote) => (
                <CareNoteCard
                  key={`cnc_${carenote.createdAt}`}
                  data={carenote}
                />
              ))}
        </Card>
      </Flex>
    </Flex>
  );
}
